import { darken,makeStyles } from '@material-ui/core';
import MaterialTable from 'material-table';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { COLORS_PROJECT, REALTIME_INTERVAL_SECONDS } from '../../../constants';
import { dataAxureFetch } from '../../../helpers/fetch';
import { IconSwitch } from './IconSwitch';
import { IconSwitchLevel } from './IconSwitchLevel';


const { color_nav, color_nav_letter } = COLORS_PROJECT;

const useStyles = makeStyles(()=>({
    circle: {  
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
}))

 

export const AnnouncersDescriptionTable = ({ filters, getDataToggle, realtime }) => {
    const classes = useStyles();
    const uid = useSelector((state) => state.auth.uid);
    const ptws = useSelector((state) => state.auth.ptws);

    const [points, setPoints] = useState([]);

    /**
     * Allow to change if real time or not, charge data
     */
    useEffect(() => {
        if (!realtime) {
            return;
        }
        getPointsRealtime();
        let unmounted = false;
        const interval = setInterval(() => {
            if (!unmounted) {
                getPointsRealtime();
            }
        }, REALTIME_INTERVAL_SECONDS * 1000);
        return () => {
            if (!realtime) {
                return;
            }
            unmounted = true;
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Charge data if no realtime
     */
    useEffect(() => {
        if (getDataToggle) {
            getPoints();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDataToggle]);

    /**
     * To get data to real Time
     */
    const getPointsRealtime = async () => {
        try {
            const newPoints = await dataAxureFetch({solicitud:"Anunciadores",idCliente:uid,ptws:ptws},'POST');
            if(newPoints){
                setPoints(newPoints);
            }
        } catch (error) {
            console.log(error);
        }
    };

    /**
     * To get data to historic
     */
    const getPoints = async () => {
        const response = await dataAxureFetch(
            {
                nomHRT: filters.pointName,
                idCliente: uid,
                fecIHRT: filters.startDate,
                fecFHRT: filters.endDate,
            },
            'POST',
        );
        const newPoints = response['0'] ? response['0'].puntos_alertados : [];
        setPoints(newPoints);
    };

    return (
        <>
            <MaterialTable
                columns={[
                    {
                        field: 'nombre',
                        title: 'Dispositivo',
                        cellStyle: {
                            width: '600px',
                            maxWidth: 600,
                            paddingRight: 0,
                        },
                    },
                    {
                        field: 'estado',
                        title: 'Estado/Nivel',
                        render: (rowData) => (
                            <div className={classes.circle}>
                                <IconSwitch number={rowData.estado} sizePixels={9} /> 
                                / 
                                <IconSwitchLevel number={rowData.nivel} sizePixels={9}/>
                            </div>
                        ),
                        defaultSort: 'asc',
                        cellStyle: {
                            width: '10px',
                            maxWidth: 10,
                        },
                    },
                   
                ]}
                data={points}
                options={{
                    padding: 'dense',
                    showTitle: false,
                    search: false,
                    toolbar: false,
                    headerStyle: {
                        backgroundColor: darken(color_nav, 0.2),
                        color: color_nav_letter,
                    },
                    maxBodyHeight: 200,
                    pageSizeOptions: [20, 30],
                    pageSize: 40,
                }}
                localization={{
                    pagination:{
                        labelRowsSelect: 'filas',
                        firstAriaLabel: 'Primera página',
                        firstTooltip: 'Primera página',
                        previousAriaLabel: 'Página anterior',
                        previousTooltip: 'Página anterior',
                        nextAriaLabel: 'Página siguiente',
                        nextTooltip: 'Página siguiente',
                        lastAriaLabel: 'Ultima página',
                        lastTooltip: 'Ultima página'
                    }
                }}
                style={{
                    height: 210,
                    overflowY: 'hidden',
                    overflowX:'hidden'
                }}
               
            />
        </>
    );
};

AnnouncersDescriptionTable.propTypes = {
    filters: PropTypes.object,
    getDataToggle: PropTypes.bool,
    realtime: PropTypes.bool.isRequired,
};
